import { contentStore, isContentDraft } from '@lib/store/Contentstore';
import { LoaderFunction, LoaderFunctionArgs } from 'react-router-dom';
import { QueryClient } from '@tanstack/react-query';
import { userInfoQueryOptions } from '../iam/userInfoQuery';
import { navigationQueryOptions } from './Navigation/navigationQuery';

export const layoutLoaderClosure: (queryClient: QueryClient) => LoaderFunction = (queryClient: QueryClient) => {
  const layoutLoader: LoaderFunction = async ({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const params = new URLSearchParams(url.search);
    const mode = params.get('mode');
    if (mode === '1') contentStore.set(isContentDraft, true);

    void queryClient.prefetchQuery(userInfoQueryOptions);
    void queryClient.prefetchQuery(navigationQueryOptions);

    return null;
  };

  return layoutLoader;
};
